import { ImageSourcePropType } from "react-native";

const STYLE_PREVIEWS: Record<string, ImageSourcePropType> = {
  fantasy: require("../../assets/style-previews/fantasy.webp"),
  manga: require("../../assets/style-previews/manga.webp"),
  comic_book: require("../../assets/style-previews/comic_book.webp"),
  "3d_movie": require("../../assets/style-previews/3d_movie.webp"),
  polygon: require("../../assets/style-previews/polygon.webp"),
  canine_dude: require("../../assets/style-previews/canine_dude.webp"),
  golden_age_illustration: require("../../assets/style-previews/golden_age_illustration.webp"),
  soft_pastel: require("../../assets/style-previews/soft_pastel.webp"),
  watercolor_storybook: require("../../assets/style-previews/watercolor_storybook.webp"),
};

export default STYLE_PREVIEWS;
